import App from "./App.vue";
import Vue from "vue";
import router from "./router";
import store from "./store/";
import { axios } from "@/utils/request";
import mermaid from 'mermaid'
// import "@babel/polyfill";
import 'core-js/stable';
import 'regenerator-runtime/runtime';
import "lib-flexible";
import "es6-promise/auto";
import Antd from "ant-design-vue";
import "ant-design-vue/dist/antd.css";
import GlobalLoader from "jpaas-component/utils/globalLoader.js";

// 全局后置钩子-常用于结束动画等
// router.afterEach(transition => {
// NProgress结束进度条
// NProgress.done()
// console.log(transition)
// })
// 初始化Mermaid配置
mermaid.initialize({
  startOnLoad: false, // 禁用自动初始化
  theme: 'default',
  flowchart: { 
    useMaxWidth: false,
    htmlLabels: true
  }
})

// 注册全局方法（可选）
Vue.prototype.$mermaid = mermaid

Vue.use(Antd);
Vue.config.productionTip = false;
Vue.prototype.$BASE_URL = process.env.BASE_URL;

Vue.prototype.$GlobalLoader = GlobalLoader;
Vue.prototype.axios = axios;
Vue.prototype.$bus = new Vue();

router.beforeEach((to, from, next) => {
  /* 路由发生变化修改页面title */
  if (to.meta.title) {
    document.title = to.meta.title;
  }
  next();
});
new Vue({
  router,
  store,
  render: (h) => h(App),
}).$mount("#app");
